// PLUZE-CUSTOM: SIGNATURE-ON-SEND
import {
  appendSignature,
  removeSignature,
  getEffectiveChannelType,
} from './editorHelper';

// Only migrate a recognizable complete legacy signature, never an agent's
// sentence that merely ends with the same name as their signature.
export function signatureFreeDraft(body, signature, channelType) {
  if (!signature || !/\n\s*--\s*\n/.test(body)) return body;
  return removeSignature(body, signature, channelType);
}

export function signatureOnSend({
  body = '',
  signature = '',
  enabled = false,
  isPrivate = false,
  channelType,
  medium = '',
}) {
  if (isPrivate || !enabled || !signature.trim() || !body.trim()) return body;
  return appendSignature(
    body,
    signature,
    getEffectiveChannelType(channelType, medium)
  );
}
// PLUZE-CUSTOM-END: SIGNATURE-ON-SEND
